import Contact, { IContact, IContactApiModel } from './Contact.model';

export interface IManufacturerContact {
  id: number;
  contactId: string;
  contact: IContact;
}

export interface IManufacturerContactApiModel {
  id: number;
  contactId: string;
  contact: IContactApiModel;
}

export default class ManufacturerContact implements IManufacturerContact {
  public readonly id: number;

  public readonly contactId: string;

  public readonly contact: IContact;

  constructor(id: number, contactId: string, contact: IContact) {
    this.id = id;
    this.contactId = contactId;
    this.contact = contact;
  }

  static fromApiModel(apiModel: IManufacturerContactApiModel) {
    const { id, contactId } = apiModel;

    const contact = Contact.fromApiModel(apiModel.contact);

    return new ManufacturerContact(id, contactId, contact);
  }

  static arrayFromApiModel(arrayApiModel: IManufacturerContactApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      const { id, contactId } = apiModel;

      const contact = Contact.fromApiModel(apiModel.contact);

      return new ManufacturerContact(id, contactId, contact);
    });

    return array;
  }
}
